// Used in projects components that were moved from intranet without refactoring.
// Not recommended to use in new code.
// Should be removed with projects module refactor. Just use date-fns

export default {
  methods: {
    formatDate(date) {
      if (date) {
        const d = new Date(date);
        if (d instanceof Date && !isNaN(d)) {
          let [year, month, day] = date.split('-');
          if (!year) {
            year = '2010';
          }
          if (!month) {
            month = '01';
          }
          if (!day) {
            day = '01';
          }
          return `${year}-${month}-${day}`;
        }
        return null;
      }
      return null;
    },

    formatInputDate(type, date) {
      const formattedDate = this.formatDate(date);
      this.dataToFilter[type] = formattedDate;
      this.dataToFilter.chipData[type] = formattedDate;
    },
  },
};
